var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yh-contaner"},[_c('MenuList',{staticStyle:{"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }